export enum patientSectionModeEnum {
    ReadOnly = 'read-only',
    InlinePatientApp = 'inline-patient-app',
    Loading = 'loading'
}